export enum QuantifyActionType {
  INIT = 'INIT',
  INIT_QUERY = 'INIT_QUERY',
  SET_QUERY = 'SET_QUERY',
  RESET_QUERY = 'RESET_QUERY',
  INIT_METADATA = 'INIT_METADATA',
  SET_METADATA = 'SET_METADATA',
  SET_VISUAL = 'SET_VISUAL',
  SET_REPORT_DATA = 'SET_REPORT_DATA',
  SET_MISC = 'SET_MISC',
}
